import type { LocationQuery } from '#vue-router'

export const queryValueToBooleanOrNull = (value: LocationQuery[string]): boolean | null => (value === 'true' || value === 'false' ? value === 'true' : null)
